import { render, staticRenderFns } from "./BaseQuestion.vue?vue&type=template&id=108268c9&"
import script from "./BaseQuestion.vue?vue&type=script&lang=js&"
export * from "./BaseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./BaseQuestion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports